import { useSelector } from 'react-redux';
import { Table } from 'antd';

import { formatDate, useGetWindowSize, i18, translationGroups, trb } from 'src/Utilities';

import { PAGINATION_DEFAULTS } from 'src/Config';
import { Number } from 'src/Components';

interface IProps {
  handleChangePagination: (pagination: any) => void;
}

export const OperationsListContainer = ({ handleChangePagination }: IProps) => {
  const windowSize = useGetWindowSize();
  const { sendODLPaging, ODLPaging, ODLPagination } = useSelector((state: any) => state.OMCReducers);

  const setStatus = (value: any) => {
    switch (value) {
      case 0:
        return trb(i18.PaymentStatuses.Ongoing);
      case 1:
        return trb(i18.PaymentStatuses.Completed);
      case 2:
        return trb(i18.PaymentStatuses.Rejected);
      case 3:
        return trb(i18.PaymentStatuses.InsufficientBalance);
      default:
        return trb(i18.PaymentStatuses.AllOperations);
    }
  };

  const translateStatusCode = (statusCode: string) => {
    const translationKey = translationGroups.OperationStatusCode + statusCode;

    const translationValue = trb(translationKey);

    if (translationValue === translationKey) {
      return statusCode;
    }

    return translationValue;
  };

  const columns = [
      {
        title: trb(i18.Labels.OperationsData),
        dataIndex: 'DateFormatted',
        render: (value: any) => <span className="text-nowrap">{formatDate(value)}</span>,
        width: 105,
      },
      {
        title: trb(i18.Labels.OperationsListPayer),
        dataIndex: 'SenderName',
        render: (value: any, item: any) => (
          <>
            <div>{value}</div>
            <div className="text-nowrap">{item.SenderAccount}</div>
          </>
        ),
        width: 215,
      },
      {
        title: trb(i18.Labels.OperationsPayee),
        dataIndex: 'ReceiverName',
        render: (value: any, item: any) => (
          <>
            <div>{value}</div>
            <div className="text-nowrap">{item.ReceiverAccount}</div>
          </>
        ),
        width: 275,
      },
      {
        title: trb(i18.Labels.OperationsListDescription),
        dataIndex: 'Description',
        className: 'word-wrap',
        width: 210,
      },
      {
        title: trb(i18.Labels.OperationStatus),
        render: (_value: any, item: any) => (
          <div>
            <div className="fw-semibold">{setStatus(item?.Status)}</div>
            <div>{translateStatusCode(item.StatusCode)}</div>
          </div>
        ),
        width: 190,
      },
      {
        title: trb(i18.Labels.OperationsSum),
        render: (item: any) => (
          <Number
            className="text-nowrap"
            value={item.Amount[0].Value}
            suffix={` ${item.Amount[0].Currency}`}
          />
        ),
        className: 'text-right',
        width: 90,
      },
    ],
    columnsMobile = [
      {
        title: trb(i18.Labels.OperationsPayer),
        dataIndex: 'SenderName',
        render: (value: any, item: any) => (
          <span>
            {value}
            <br />
            {item.SenderAccount}
          </span>
        ),
      },
      {
        title: trb(i18.Labels.OperationsSum),
        render: (item: any) => (
          <Number
            className="text-nowrap"
            value={item.Amount[0].Value}
            suffix={` ${item.Amount[0].Currency}`}
          />
        ),
        className: 'text-right',
      },
    ];

  return (
    <Table
      id="OperationsListTable"
      loading={sendODLPaging}
      aria-busy={sendODLPaging}
      dataSource={ODLPaging.OperationList.map((item: any, index: number) => ({
        ...item,
        UIDForTableUpdate: index,
      }))}
      rowKey="UIDForTableUpdate"
      columns={windowSize.mobileCheck ? columnsMobile : columns}
      className="mb-5 mx-0 overflow_x_auto operations-list-table"
      tableLayout="fixed"
      pagination={{
        showSizeChanger: true,
        hideOnSinglePage: ODLPaging.RowsCount <= PAGINATION_DEFAULTS.OPERATIONS.SIZES[0],
        pageSizeOptions: PAGINATION_DEFAULTS.OPERATIONS.SIZES,
        current: ODLPagination.PageNumber,
        pageSize: ODLPagination.PageSize,
        total: ODLPaging.RowsCount,
        onChange: (page, size) =>
          handleChangePagination({
            Days: ODLPagination.Days,
            PageNumber: page,
            PageSize: size,
            OperationStatus: ODLPagination.OperationStatus,
          }),
        onShowSizeChange: (_current, size) =>
          handleChangePagination({
            Days: ODLPagination.Days,
            PageNumber: 1,
            PageSize: size,
            OperationStatus: ODLPagination.OperationStatus,
          }),
      }}
    />
  );
};
